import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from 'react-router-dom';
import IconButtonComponent from "../components/IconButtonComponent";
import ButtonComponent from "../components/ButtonComponent";
import MySpinner from "../components/MySpinner";
import RadioButton from "../components/RadioButton";
import '../assets/styles/radio-button.css';
import { sendSupportMessage,getAllMessagesSubjectAsync } from '../services/supportMessageService';  
import { useAuth } from "../auth/AuthContext";
import { Modal } from "react-bootstrap";


function SupportPage() {
  const [messageContent, setMessageContent] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [messagesTypes, setMessagesTypes] = useState([]); 
  const [selectedType, setSelectedType] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(true);    
  const navigate = useNavigate();

 const { userInfo } = useAuth();
  const senderEmail = userInfo?.empEmail;
  
  const handleRadioChange = (event) => {
    setSelectedType(event.target.value);
  }; 
  const handleTextAreaChange = (event) => {
    setMessageContent(event.target.value);
  };

  const handleSubmit = async () => {
     const confirmed = window.confirm("هل أنت متأكد أنك تريد إرسال الرسالة؟");
  if (!confirmed) return;
    try {
      if (!messageContent.trim()) {
        setErrorMessage("الرجاء كتابة رسالة قبل الإرسال");
        return;
      }
      if (!senderEmail || senderEmail === "")
        {
          setErrorMessage("لم يتم العثور على ايميل ، الرجاء تحديث حسابك الشخصي .")
          return;
        }
        if (!selectedType || selectedType === "")
          {
            setErrorMessage("يجب اختيار نوع الرسالة اولا.")
            return;
          }
  
      const messageObject = {
        clientEmail: senderEmail,
        messageTypeId: selectedType,
        messageBody: messageContent
      };
     
      await sendSupportMessage(messageObject);
      setSuccessMsg("تم ارسال الرسالة بنجاح");
       setShowSuccessModal(true);
      
  
    } catch (error) {
      setErrorMessage("حدث خطأ أثناء إرسال الرسالة، يرجى المحاولة مرة أخرى.");
    }
  };

const handleSuccessClose = () => {
  setShowSuccessModal(false);  
  setSelectedType("generalInquiry"); 
  setMessageContent(""); 
  navigate("/")
};
 

useEffect(() => {
  const fetchMessagesTypes = async () => {
    try {
      setLoading(true);
      const response = await getAllMessagesSubjectAsync()
      setMessagesTypes(response);  
    } catch (error) {
      setErrorMessage(error.message || "حدث خطأ اثناء جلب انواع الرسائل")
    }finally {
      setLoading(false); 
    }
  };

  fetchMessagesTypes();
}, []);
  return (
    <Layout>
      <Modal show={showSuccessModal} onHide={handleSuccessClose}>
  <Modal.Header closeButton>
    <Modal.Title>تم إرسال الرسالة بنجاح</Modal.Title>
  </Modal.Header>
  <Modal.Body>{successMsg}</Modal.Body>
  <Modal.Footer>
    <ButtonComponent text="حسنا" className="primary-bg" onClick={handleSuccessClose} />
  </Modal.Footer>
</Modal>
      <div className="d-flex flex-column  align-items-center">
    {errorMessage ? <div className="danger-bg white-color p-1 border-radius-5"> {errorMessage}</div> : null}
      <div className=" col-12 d-flex flex-wrap justify-content-evenly">
  
      {loading ? (
        <div className="text-center">
          <MySpinner />  
        </div>
      ) : (
        messagesTypes
    .filter((type) => type.enTypeName !== "resetPassword")  
    .map((type) => (
      <div key={type.typeId}>
        <RadioButton
          label={type.arTypeName} 
          group="filterType"
          value={type.typeId} 
          checked={selectedType === String(type.typeId)}  
          onChange={handleRadioChange}
        />
      </div>
        ))
      )}
</div>

<textarea
  className="no-outline col-10 my-3 text-area"
  name="supportMsg"
  id="supportMessage"
  placeholder="اكتب رسالتك هنا"
  value={messageContent}
  onChange={handleTextAreaChange}
/>
<IconButtonComponent
  icon={faEnvelope}
  onClick={handleSubmit}
  hint="ارسال"
/>
      </div>
    </Layout>
  );
}

export default SupportPage;
